<template>
<div>
<!-- <app-header></app-header> -->
<div class="l-container">
   <div class="recruit">
        <div class="recruit-top">
            <h1>제오젠과 <span class="ib">새로운 시작을</span> <span class="ib">함께 할</span><br> <span class="ib">멤버를</span> <span class="ib">찾고</span> <span class="ib">있습니다.</span></h1>
            <p>제오젠은 기업의 브랜드 가치를 높일 수 있는 마케팅과 디자인 업무를 담당하며,<br>
                브랜드 이미지를 일관되게 유지하는 것과 더불어 고도화 하는 역할을 하고 있습니다.<br>
                우리와 이러한 업무를 함께할 새로운 멤버를 찾습니다.</p>
       </div>
       <dl class="recruit-team">
           <dt><a href="javascript:;">UX디자인팀</a></dt>
           <dd>
               <div class="recruit-docs">
                   <h2 class="tit">제오젠 UX디자인팀에서<br> 경력직 UI디자이너를 모집합니다.</h2>
                   <dl class="recruit-docs-detail">
                       <dt>담당업무</dt>
                       <dd>
                           <ul>
                               <li>UI 디자이너</li>
                           </ul>
                       </dd>
                       <dt>지원자격</dt>
                       <dd>
                           <ul>
                               <li>경력 5년 이상 ~ 8년 이하</li>
                           </ul>
                       </dd>
                       <dt>근무조건</dt>
                       <dd>
                           <ul class="type-dl">
                               <li><strong class="tit">고용형태</strong> 정규직</li>
                               <li><strong class="tit">근무시간</strong> 주 5일(월~금) 탄력근무제: 출근 08:00~10:00 / 퇴근 17:00~19:00</li>
                               <li><strong class="tit">지역</strong> 서울시 강남구 테헤란로 151 역삼하이츠빌딩 패스트파이브 424호</li>
                               <li><strong class="tit">급여</strong> 회사내규에 따름(면접 후 결정)</li>
                           </ul>
                       </dd>
                       <dt>우대사항</dt>
                       <dd>
                           <ul>
                               <li>디자인 관련 전공자 우대</li>
                               <li>해당 분야 PL급 경력자</li>
                               <li>디자인 전략 및 컨셉을 주도적으로 제안할 수 있는 사람</li>
                               <li>인터랙션 디자인에 대한 이해도가 높은 사람</li>
                               <li>프로토타이핑툴 사용이 가능한 사람 (ex. Sketch, Adobe XD, Protopie 등) </li>
                               <li>프로젝트 단위의 리딩 유경험자</li>
                           </ul>
                       </dd>
                       <dt>지원서류 및 지원 방법</dt>
                       <dd>
                           <ul>
                               <li>자기소개서(이력서포함)</li>
                               <li>본인역량을 보여줄 수 있는 산출물이 포함된 자료 및 개인사이트 첨부</li>
                               <li>
                                   지원서는 이메일을 통해서 제출 <a href="mailto:recruit_design@xeogen.com">recruit_design@xeogen.com</a><br>
                                   (이메일 제출 시 제목앞에 <em>[입사지원/UX디자인팀]</em>을 기입해 주시기 바랍니다.)
                                </li>
                               <li>사람인 온라인 입사지원/잡코리아 온라인 입사지원</li>
                               <li>입사관련 문의는 이메일로만 받습니다.</li>
                           </ul>
                       </dd>
                       <dt>복지 및 혜택</dt>
                       <dd>
                           <ul>
                               <li>장기근속자에 대한 포상휴가 및 여행경비 지급 (3년/6년/9년)</li>
                               <li>사원을 위한 생일파티 및 백화점 상품권 지급</li>
                               <li>자녀 학자금 지원</li>
                               <li>도서/교육비 지원</li>
                               <li>야근시 야근 식대 및 야근 교통비 지원</li>
                               <li>비흡연자를 위한 건강장려휴가</li>
                               <li>주 5일근무/4대보험/연차/육아휴직 등 법정 복리후생 지원</li>
                               <li>창립기념일행사, 워크샵</li>
                           </ul>
                       </dd>
                   </dl>
               </div>
           </dd>
           <dt><a href="javascript:;">W퍼블리싱팀</a></dt>
           <dd>
               <div class="recruit-docs">
                   <h2 class="tit">제오젠 W퍼블리싱팀에서<br> 경력직 웹퍼블리셔를 모집합니다.</h2>
                   <dl class="recruit-docs-detail">
                       <dt>담당업무</dt>
                       <dd>
                           <ul>
                               <li>웹 퍼블리싱</li>
                           </ul>
                       </dd>
                       <dt>지원자격</dt>
                       <dd>
                           <ul>
                               <li>경력 2년이상 ~ 8년 이하</li>
                               <li>웹 표준 및 웹 접근성에 대한 이해가 높은 분</li>
                               <li>자바스크립트 (or jQuery) 직접 작성 가능하신 분</li>
                               <li>반응형 사이트 구현 가능하신 분</li>
                           </ul>
                       </dd>
                       <dt>근무조건</dt>
                       <dd>
                           <ul class="type-dl">
                               <li><strong class="tit">고용형태</strong> 정규직</li>
                               <li><strong class="tit">근무시간</strong> 주 5일(월~금) 탄력근무제: 출근 08:00~10:00 / 퇴근 17:00~19:00</li>
                               <li><strong class="tit">지역</strong> 서울시 강남구 테헤란로 151 역삼하이츠빌딩 패스트파이브 424호</li>
                               <li><strong class="tit">급여</strong> 회사내규에 따름(면접 후 결정)</li>
                           </ul>
                       </dd>
                       <dt>우대사항</dt>
                       <dd>
                           <ul>
                               <li>프로젝트 퍼블리싱 파트 리딩 경험</li>
                               <li>SPA Framework 활용 경험</li>
                               <li>Webpack, Gulp, Sass 사용 경험</li>
                               <li>형상관리 (SVN, GIT) 사용 경험</li>
                               <li>Javascript (ES6) 사용 경험</li>
                           </ul>
                       </dd>
                       <dt>지원서류 및 지원 방법</dt>
                       <dd>
                           <ul>
                               <li>이력서 &amp; 자기 소개서 (필수 - 경력 위주)</li>
                               <li>본인 역량을 보여줄 수 있는 개인 사이트 주소(선택)</li>
                               <li>
                                   지원서는 이메일을 통해서 제출 <a href="mailto:recruit_pub@xeogen.com">recruit_pub@xeogen.com</a><br>
                                   (이메일 제출 시 제목앞에 <em>[입사지원/W퍼블리싱팀]</em>을 기입해 주시기 바랍니다.)
                                </li>
                               <li>사람인 온라인 입사지원/잡코리아 온라인 입사지원</li>
                               <li>입사관련 문의는 이메일로만 받습니다.</li>
                           </ul>
                       </dd>
                       <dt>복지 및 혜택</dt>
                       <dd>
                           <ul>
                               <li>장기근속자에 대한 포상휴가 및 여행경비 지급 (3년/6년/9년)</li>
                               <li>사원을 위한 생일파티 및 백화점 상품권 지급</li>
                               <li>자녀 학자금 지원</li>
                               <li>도서/교육비 지원</li>
                               <li>야근시 야근 식대 및 야근 교통비 지원</li>
                               <li>비흡연자를 위한 건강장려휴가</li>
                               <li>주 5일근무/4대보험/연차/육아휴직 등 법정 복리후생 지원</li>
                               <li>창립기념일행사, 워크샵</li>
                           </ul>
                       </dd>
                   </dl>
               </div>
           </dd>
           <dt><a href="javascript:;">e-Service기획실</a></dt>
           <dd>
               <div class="recruit-docs">
                   <h2 class="tit">제오젠 e-Service기획실에서<br> 신입/경력직 기획자를 모집합니다.</h2>
                   <dl class="recruit-docs-detail">
                       <dt>담당업무</dt>
                       <dd>
                           <ul>
                               <li>UI/UX, 서비스 기획 및 웹/모바일 관련 기획 담당 (구축, 유지보수)</li>
                           </ul>
                       </dd>
                       <dt>지원자격</dt>
                       <dd>
                           <ul>
                               <li>경력 1년이상 ~ 9년이하</li>
                           </ul>
                       </dd>
                       <dt>근무조건</dt>
                       <dd>
                           <ul class="type-dl">
                               <li><strong class="tit">고용형태</strong> 정규직</li>
                               <li><strong class="tit">근무시간</strong> 주 5일(월~금) 탄력근무제: 출근 08:00~10:00 / 퇴근 17:00~19:00</li>
                               <li><strong class="tit">지역</strong> 서울시 강남구 테헤란로 151 역삼하이츠빌딩 패스트파이브 424호</li>
                               <li><strong class="tit">급여</strong> 회사내규에 따름(면접 후 결정)</li>
                           </ul>
                       </dd>
                       <dt>우대사항</dt>
                       <dd>
                           <ul>
                               <li>해당 분야 PM/PL급 경력자</li>
                               <li>제안 전략을 주도적으로 제안할 수 있는 사람</li>
                               <li>쇼핑몰, 금융 구축 및 유지보수 경력자</li>
                           </ul>
                       </dd>
                       <dt>지원서류 및 지원 방법</dt>
                       <dd>
                           <ul>
                               <li>이력서 &amp; 자기 소개서 (필수 - 경력 위주)</li>
                               <li>본인 역량을 보여줄 수 있는 개인 사이트 주소(선택)</li>
                               <li>
                                   지원서는 이메일을 통해서 제출 <a href="mailto:recruit-espd@xeogen.com">recruit-espd@xeogen.com</a><br>
                                   (이메일 제출 시 제목앞에 <em>[입사지원/e-Service기획실]</em>을 기입해 주시기 바랍니다.)
                                </li>
                               <li>사람인 온라인 입사지원/잡코리아 온라인 입사지원</li>
                               <li>입사관련 문의는 이메일로만 받습니다.</li>
                           </ul>
                       </dd>
                       <dt>복지 및 혜택</dt>
                       <dd>
                           <ul>
                               <li>장기근속자에 대한 포상휴가 및 여행경비 지급 (3년/6년/9년)</li>
                               <li>사원을 위한 생일파티 및 백화점 상품권 지급</li>
                               <li>자녀 학자금 지원</li>
                               <li>도서/교육비 지원</li>
                               <li>야근시 야근 식대 및 야근 교통비 지원</li>
                               <li>비흡연자를 위한 건강장려휴가</li>
                               <li>주 5일근무/4대보험/연차/육아휴직 등 법정 복리후생 지원</li>
                               <li>창립기념일행사, 워크샵</li>
                           </ul>
                       </dd>
                   </dl>
               </div>
           </dd>
           <dt><a href="javascript:;">IT 개발실</a></dt>
           <dd>
               <div class="recruit-docs">
                   <h2 class="tit">제오젠 IT개발실에서<br> JAVA 웹 개발자를 모집합니다. (신입 &amp; 경력)</h2>
                   <dl class="recruit-docs-detail">
                       <dt>담당업무</dt>
                       <dd>
                           <ul>
                               <li>웹 사이트 구축 및 유지보수 업무 진행</li>
                           </ul>
                       </dd>
                       <dt>지원자격</dt>
                       <dd>
                           <ul>
                               <li>신입/경력 1년 ~ 5년</li>
                           </ul>
                       </dd>
                       <dt>근무조건</dt>
                       <dd>
                           <ul class="type-dl">
                               <li><strong class="tit">고용형태</strong> 정규직</li>
                               <li><strong class="tit">근무시간</strong> 주 5일(월~금) 탄력근무제: 출근 08:00~10:00 / 퇴근 17:00~19:00</li>
                               <li><strong class="tit">지역</strong> 서울시 강남구 테헤란로 151 역삼하이츠빌딩 패스트파이브 424호</li>
                               <li><strong class="tit">급여</strong> 회사내규에 따름(면접 후 결정)</li>
                           </ul>
                       </dd>
                       <dt>지원서류 및 지원 방법</dt>
                       <dd>
                           <ul>
                               <li>자유양식의 이력서</li>
                               <li>본인 역량을 보여줄 수 있는 개인 사이트 주소(선택)</li>
                               <li>
                                   지원서는 사람인 채용 또는 이메일 접수 <a href="mailto:recruit-dvd@xeogen.com">recruit-dvd@xeogen.com</a><br>
                                   (이메일 제출 시 제목앞에 <em>[입사지원/IT개발실]</em>을 기입해 주시기 바랍니다.)
                                </li>
                               <li>입사관련 문의는 이메일로만 받습니다.</li>
                           </ul>
                       </dd>
                       <dt>복지 및 혜택</dt>
                       <dd>
                           <ul>
                               <li>장기근속자에 대한 포상휴가 및 여행경비 지급 (3년/6년/9년)</li>
                               <li>사원을 위한 생일파티 및 백화점 상품권 지급</li>
                               <li>자녀 학자금 지원</li>
                               <li>도서/교육비 지원</li>
                               <li>야근시 야근 식대 및 야근 교통비 지원</li>
                               <li>비흡연자를 위한 건강장려휴가</li>
                               <li>주 5일근무/4대보험/연차/육아휴직 등 법정 복리후생 지원</li>
                               <li>창립기념일행사, 워크샵</li>
                           </ul>
                       </dd>
                   </dl>
               </div>
           </dd>
           <dt><a href="javascript:;">전략마케팅실</a></dt>
           <dd>
               <div class="recruit-docs">
                   <h2 class="tit">제오젠 전략마케팅실에서<br> 경력직(고급/중급) 웹기획자를 모집합니다.</h2>
                   <dl class="recruit-docs-detail">
                       <dt>담당업무</dt>
                       <dd>
                           <ul>
                               <li>쇼핑/보험/카드/여행/플랫폼 등 다양한 프로젝트를 수행할 웹기획자</li>
                           </ul>
                       </dd>
                       <dt>지원자격</dt>
                       <dd>
                           <ul>
                               <li>경력 5년이상 ~ 15년 이하</li>
                           </ul>
                       </dd>
                       <dt>근무조건</dt>
                       <dd>
                           <ul class="type-dl">
                               <li><strong class="tit">고용형태</strong> 정규직</li>
                               <li><strong class="tit">근무시간</strong> 주 5일(월~금) 탄력근무제: 출근 08:00~10:00 / 퇴근 17:00~19:00</li>
                               <li><strong class="tit">지역</strong> 서울시 강남구 테헤란로 151 역삼하이츠빌딩 패스트파이브 424호</li>
                               <li><strong class="tit">급여</strong> 회사내규에 따름(면접 후 결정)</li>
                           </ul>
                       </dd>
                       <dt>우대사항</dt>
                       <dd>
                           <ul>
                               <li>쇼핑/보험/카드/여행/플랫폼 업종의 대형 프로젝트 구축 및 운영 경험자</li>
                               <li>웹기획을 잘하는 사람</li>
                               <li>해당 분야 PM 또는 PL급 경험자</li>
                           </ul>
                       </dd>
                       <dt>지원서류 및 지원 방법</dt>
                       <dd>
                           <ul>
                               <li>자기소개서(이력서포함)</li>
                               <li>본인이 작업한 화면설계서 첨부</li>
                               <li>
                                   지원서는 이메일을 통해서 제출 <a href="mailto:recruit_smd@xeogen.com">recruit_smd@xeogen.com</a><br>
                                   (이메일 제출 시 제목앞에 <em>[입사지원/전략마케팅실]</em>을 기입해 주시기 바랍니다.)
                                </li>
                               <li>사람인 온라인 입사지원/잡코리아 온라인 입사지원</li>
                               <li>입사관련 문의는 이메일로만 받습니다.</li>
                           </ul>
                       </dd>
                       <dt>복지 및 혜택</dt>
                       <dd>
                           <ul>
                               <li>장기근속자에 대한 포상휴가 및 여행경비 지급 (3년/6년/9년)</li>
                               <li>사원을 위한 생일파티 및 백화점 상품권 지급</li>
                               <li>자녀 학자금 지원</li>
                               <li>도서/교육비 지원</li>
                               <li>야근시 야근 식대 및 야근 교통비 지원</li>
                               <li>비흡연자를 위한 건강장려휴가</li>
                               <li>주 5일근무/4대보험/연차/육아휴직 등 법정 복리후생 지원</li>
                               <li>창립기념일행사, 워크샵</li>
                           </ul>
                       </dd>
                   </dl>
               </div>
           </dd>
       </dl>
   </div>    
</div>
<!-- <app-footer></app-footer> -->
</div>
</template>

<script>
// import Header from './Header.vue';
// import Footer from './Footer.vue';
export default {
   data(){
       return{
          
       }
   },
//    components: {
//        'app-header': Header,
//        'app-footer': Footer
//    },
   mounted:function(){       
       $('.recruit-team > dt').on('click','a',function(){           
           var $thisTitle = $(this).parent('dt');           
           var $teamTitle = $thisTitle.siblings('dt');
           var thisTitleTop = $thisTitle.offset().top;

           if(!$thisTitle.hasClass('is-active')){                              
               $thisTitle.addClass('is-active');
               $('html,body').stop().animate({'scrollTop':thisTitleTop + 'px'},200,function(){
                   $teamTitle.removeClass('is-active');
               });
           }else{
               $thisTitle.removeClass('is-active');
           }
       });       
   },
   created () {
    console.log('xgRecruit')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/XgRecruit.vue